import { FacebookEditActionTypes } from "./FacebookEditActionTypes";

export const adUnsyncErrored = () =>
  ({
    type: FacebookEditActionTypes.FACEBOOK_AD_UNSYNC_ERRORED,
  } as const);
